import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { ChartOptions } from 'src/app/shared/classes/chart-options';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { MatomoTracker } from 'ngx-matomo';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
interface Condition {
  ComplianceIndexCode: string;
  ComplianceIndex: string;
}

interface ItemData {
  Sid: number;
  name: string;
  age: number;
  address: string;
  schedule: string;
  uploadFileName: string;
}
@Component({
  selector: 'app-WmsmScheduleManagementComponent',
  templateUrl: './wmsm-ScheduleManagement.component.html',
  styleUrls: ['./wmsm-ScheduleManagement.component.scss'],
})

export class WmsmScheduleManagementComponent extends BaseComponent implements OnInit {
  pageSize: number = 20;
  // 表格页码
  public uploadedFileName: string;
  public ManagerEmailFileName: string;
  select: boolean = false
  SiteList: any;
  pageIndex: number = 1;
  fileList: NzUploadFile[] = [];
  total: number = 0;
  validateForm: FormGroup;
  formValues: any;
  chartOption: any;
  seriesData: any[];
  SiteAll: any;
  option: any;
  startValue: any = 10;
  endValue: any = 100;
  dataZoomOrient: any = 'horizontal';
  barChartOrient: any = 'vertical';
  loading: boolean = false;
  isShowCondition: boolean = true;
  isShowinfo: boolean = false;
  monthFormat = 'yyyy/MM/dd';
  showNoteflag: boolean;
  showchart: boolean;
  id_chart: string = 'link_Request';
  ComplianceIndexCondition: any;
  chartY: [];
  nzTitle: any;
  listOfData: readonly ItemData[] = [];
  NTBCost: any;
  tw: boolean;
  cn: boolean;
  en: boolean;
  id: any;
  myChart;
  setOfCheckedId = new Set<number>();
  listOfCurrentPageData: readonly ItemData[] = [];
  filename: any
  selectedValue: string = "";
  cancelSelection = false;
  UploadProofFile: NzUploadFile = null;
  ManagerEmailFile: NzUploadFile = null;
  isVisible = false;
  isVisible1 = false;
  checked = false;
  indeterminate = false;
  SelectData: any;
  Role: boolean = false
  VendorRole: boolean = false
  ConditionRole: any;
  IsTermination: boolean = false
  IsReject: boolean = false
  GuiID: any;
  int: any;
  fixedColumn = true;
  Code: any;
  database: any;
  constructor(
    private chart: ChartOptions,
    private fb: FormBuilder,
    private Environment: EnvironmentconfigService,
    private webApiService: WebApiService,
    private matomotracker: MatomoTracker,
    private NzMessageService: NzMessageService,
    private LayoutComponent: LayoutComponent,
    private http: HttpClient,
    private AuthService: AuthService,
    private tanslateService: TranslateService
  ) { super(); }

  ngOnInit(): void {
    this.matomotracker.trackPageView("合同管理")
    this.matomotracker.trackEvent("合同管理", "合同进度", "Transation", 1);
    this.LayoutComponent.geturl()
    this.validateForm = this.fb.group({
      ContractName: [""],
      Versions: [''],
      ContractNameEn: [''],
      schedule: [['']],
      vendorName: [''],
      Buyer: [''],
      GroundsRejection: [''],
      TerminationText: [''],
      VendorRejectText: [''],
    });
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetWHQRole.url}`;
    const params = {
    };
    this.webApiService.doGet(url, params).subscribe(
      (res) => {
        const roles = res.data as string[];
        if (roles.includes("3") || roles.includes("4") || roles.includes("0")) {
          this.Role = true
        } else if (roles.includes("2")) {
          this.VendorRole = true
        }
        this.ConditionRole = res.data[0]

      },
      (error) => {
      }
    );



    this.GetLanguage();
    this.SelectData = [];
    this.checked = false;
    this.indeterminate = false;
  }

  handleCancel() {
    this.isVisible = false
  }
  handleOk() {
    this.UserReject()
    this.isVisible = false
  }


  //駁回按鈕
  RejectButton() {
    if (this.SelectData == undefined) {
      return this.tanslateService.get('SelectData').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      // let language = sessionStorage.getItem("wmsmlang");
      // if (language == 'zh-TW') {
      //   return this.NzMessageService.warning('請選擇數據');
      // }
      // if (language == 'zh-CN') {
      //   return this.NzMessageService.warning('请选择数据');
      // }
      // if (language == 'en') {
      //   return this.NzMessageService.warning('Please select data');
      // }
    } else if (this.SelectData.length > 1) {

      return this.tanslateService.get('RejectOnlyOneData').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      // this.NzMessageService.warning('只能駁回一條數據');

    } else if (this.SelectData.length == 0 || this.SelectData == undefined) {
      return this.tanslateService.get('SelectData').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      //this.NzMessageService.warning('請選擇數據');
    } else if (this.SelectData.length == 1 && this.SelectData[0].schedule != "1") {
      return this.tanslateService.get('OnlyUploadsCanRejected').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      //this.NzMessageService.warning('只能駁回已上傳');
    } else if (this.SelectData.length == 1 && this.SelectData[0].schedule == "1") {
      this.isVisible = true

      this.validateForm.controls['GroundsRejection'].setValue(null);
    }
  }



  //核准按钮
  Approve() {

    if (this.SelectData === undefined || this.SelectData.length == 0 || this.SelectData === null) {


      return this.tanslateService.get('SelectData').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      // let language = sessionStorage.getItem("wmsmlang");
      // if (language == 'zh-TW') {
      //   return this.NzMessageService.warning('請選擇數據');
      // }
      // if (language == 'zh-CN') {
      //   return this.NzMessageService.warning('请选择数据');
      // }
      // if (language == 'en') {
      //   return this.NzMessageService.warning('Please select data');
      // }
    }
    if (this.SelectData[0].schedule == "1" || this.SelectData[0].schedule == "3") {
      var dd = "NoRejected"
      this.SelectData.forEach(data => {
        if (data.schedule == "3") {
          dd = "rejected"

          // 在这里添加对schedule属性值的判断代码
        }
      })


      if (this.SelectData == undefined) {
        return this.tanslateService.get('SelectData').subscribe((translatedText: string) => {
          this.NzMessageService.warning(translatedText);
        })
        // let language = sessionStorage.getItem("wmsmlang");
        // if (language == 'zh-TW') {
        //   return this.NzMessageService.warning('請選擇數據');
        // }
        // if (language == 'zh-CN') {
        //   return this.NzMessageService.warning('请选择数据');
        // }
        // if (language == 'en') {
        //   return this.NzMessageService.warning('Please select data');
        // }
      } else
        if (this.SelectData.length == 0) {
          return this.tanslateService.get('SelectData').subscribe((translatedText: string) => {
            this.NzMessageService.warning(translatedText);
          })
          // let language = sessionStorage.getItem("wmsmlang");
          // if (language == 'zh-TW') {
          //   return this.NzMessageService.warning('請選擇數據');
          // }
          // if (language == 'zh-CN') {
          //   return this.NzMessageService.warning('请选择数据');
          // }
          // if (language == 'en') {
          //   return this.NzMessageService.warning('Please select data');
          // }
        } else if (this.SelectData.length == 1 && dd == "rejected") {
          this.isVisible1 = true

        } else if (this.SelectData.length == 1 && dd == "NoRejected") {
          this.ApproveContractOfUpload()
        }
        else if (this.SelectData.length > 1 && dd == "NoRejected") {
          this.ApproveContractOfUpload()
        }
        else if (this.SelectData.length > 1 && dd == "rejected") {

          return this.tanslateService.get('CheckSelected').subscribe((translatedText: string) => {
            this.NzMessageService.warning(translatedText);
          })

          // let language = sessionStorage.getItem("wmsmlang");
          // if (language == 'zh-TW') {
          //   return this.NzMessageService.warning('所選擇的資料中含有拒簽，請檢查');
          // }
          // if (language == 'zh-CN') {
          //   return this.NzMessageService.warning('所选数据含有拒签，请检查');
          // }
          // if (language == 'en') {
          //   return this.NzMessageService.success('Please check that the selected information contains visa rejection');
          // }
        }
    } else {
      return this.tanslateService.get('CannotApprovedThisState').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      // this.NzMessageService.warning('該狀態下不能核准');
      // let language = sessionStorage.getItem("wmsmlang");
      // if (language == 'zh-TW') {
      //   return this.NzMessageService.warning('該狀態下不能核准');
      // }
      // if (language == 'zh-CN') {
      //   return this.NzMessageService.warning('该状态下不能核准');
      // }
      // if (language == 'en') {
      //   return this.NzMessageService.success('Cannot be approved in this state');
      // }
    }



  }

  //状态为拒签下的上传档案



  GetLanguage() {
    if (sessionStorage.getItem("wmsmlang") == "zh-CN") {
      this.cn = true;
      this.tw = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "zh-TW") {
      this.tw = true;
      this.cn = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "en") {
      this.en = true;
      this.cn = false;
      this.tw = false;
    }
  }

  getFormValue(value) {
    this.formValues = value;
  }

  getQuery(value) {
    this.isShowCondition = value;
  }

  onSearch() {
    this.isShowCondition = !this.isShowCondition;
    this.loading = true;
    this.GetLanguage();
    this.GetTable()

  }

  showNote(note: string): void {
    if (note == 'isshowNote') {
      this.showNoteflag = true;
    }
  }

  CloseNote(note: string): void {
    this.showNoteflag = false;
  }





  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.total === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.total && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.GetTable()
  }

  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.GetTable()
  }


  GetTable() {
    this.loading = true;
    const startDate = this.formValues.SendDate !== null ? this.getUTC8DateString(this.formValues.SendDate[0]) : '';
    const endDate = this.formValues.SendDate !== null ? this.getUTC8DateString(this.formValues.SendDate[1]) : '';
    // 移除加一天的處理，直接傳遞原始時間
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetContractScheduleList.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        Site: this.formValues.Site,
        ContractName: this.formValues.ContractName,
        Version: this.formValues.Versions,
        Schedule: this.formValues.Schedule,
        VendorCode: this.formValues.Vendor,
        Buyer: this.formValues.Buyer,
        TypeCode: this.formValues.TypeCode,
        SendDateFrom: startDate,
        SendDateTo: endDate,
      }
    };
    this.webApiService.doPost(url, params).subscribe((res) => {
      this.listOfData = res.data.map((item, index) => ({
        Sid: index,
        buyer: item.buyer,
        buyerName: item.buyername,
        chContractName: item.chContractName,
        expirationDate: item.expirationDate,
        id: item.id,
        pendingDays: item.pendingDays,
        rejectNote: item.rejectNote,
        schedule: item.schedule,
        sendDate: item.sendDate,
        status: item.status,
        terminationNote: item.terminationNote,
        vendorCode: item.vendorCode,
        vendorName: item.vendorName,
        versions: item.versions,
        site: item.site,
        email: item.email,
        templateFileToken: item.templateFileToken,
        vendorUptateFileToken: item.vendorUptateFileToken,
        templateFileName: item.templateFileName,
        uploadFileName: item.uploadFileName,
        approveDate: item.approveDate,
        vendorPhone: item.vendorPhone,
        vendorOperationDate: item.vendorOperationDate,
        contractScheduleID: item.contractScheduleID,
        managerEmailFileName: item.managerEmailFileName,
        managerEmailFileToken: item.managerEmailFileToken,
        TypeCode: item.typeCode,
      }));
      this.total = res.total
      this.tanslateService.get('QuerySuccess').subscribe((translatedText: string) => {
        this.NzMessageService.success(translatedText);
      })
      this.loading = false;
      this.setOfCheckedId.clear();
      this.checked = false;
      this.indeterminate = false;
    });
  }


  //勾選
  updateCheckedSet(Sid: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(Sid);
    } else {
      this.setOfCheckedId.delete(Sid);
    }

    var data = []
    this.setOfCheckedId.forEach(x => {
      var dto = this.listOfData.find(o => o.Sid == x);
      data.push(dto);
    })
    this.SelectData = data;

  }

  onItemChecked(Sid: number, checked: boolean): void {
    this.updateCheckedSet(Sid, checked);
    this.refreshCheckedStatus();
  }

  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach(item => {

      if (item.schedule == "0" || item.schedule == "1" || item.schedule == "3" || item.schedule == "4") {
        this.updateCheckedSet(item.Sid, value)
      }
    })
    //this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.Sid, value));

    this.refreshCheckedStatus();

  }

  onCurrentPageDataChange($event: readonly ItemData[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    if (!this.listOfCurrentPageData || this.listOfCurrentPageData.length === 0) {
      this.checked = false;
      this.indeterminate = false;
      return;
    }
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.Sid));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.Sid)) && !this.checked;
  }





  //终止按钮
  ShowTermination() {

    if (this.SelectData == undefined) {
      this.tanslateService.get('SelectData').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      // let language = sessionStorage.getItem("wmsmlang");
      // if (language == 'zh-TW') {
      //   this.NzMessageService.warning('請選擇數據');
      // }
      // if (language == 'zh-CN') {
      //   this.NzMessageService.warning('请选择数据');
      // }
      // if (language == 'en') {
      //   this.NzMessageService.warning('Please select data');
      // }
    } else
      if (this.SelectData.length > 1) {
        this.tanslateService.get('ShowTermOnlyOneData').subscribe((translatedText: string) => {
          this.NzMessageService.warning(translatedText);
        })
        // let language = sessionStorage.getItem("wmsmlang");
        // if (language == 'zh-TW') {
        //   this.NzMessageService.warning('只能终止一條數據');
        // }
        // if (language == 'zh-CN') {
        //   this.NzMessageService.warning('只能终止一条数据');
        // }
        // if (language == 'en') {
        //   this.NzMessageService.warning('Only one piece of data can be terminated');
        // }
      } else if (this.SelectData.length == 0 || this.SelectData == undefined) {
        this.tanslateService.get('SelectData').subscribe((translatedText: string) => {
          this.NzMessageService.warning(translatedText);
        })
        // let language = sessionStorage.getItem("wmsmlang");
        // if (language == 'zh-TW') {
        //   this.NzMessageService.warning('請選擇數據');
        // }
        // if (language == 'zh-CN') {
        //   this.NzMessageService.warning('请选择数据');
        // }
        // if (language == 'en') {
        //   this.NzMessageService.warning('Please select data');
        // }
      } else if (this.SelectData.length == 1) {
        this.IsTermination = true
        this.validateForm.controls['TerminationText'].setValue(null);
      }
  }


  terminationCancel() {
    this.IsTermination = false
  }

  //确定终止
  terminationOk() {
    this.Delete()
    this.IsTermination = false
  }

  Delete() {

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DeleteScheduleContract.url}`;
    const params = {
      data: {
        scheduleDto: this.SelectData,
        TerminationNote: this.validateForm.controls['TerminationText'].value,

      }
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.status = 200) {
          this.tanslateService.get('TerminatedContractReview').subscribe((translatedText: string) => {
            this.NzMessageService.warning(translatedText);
          })

          // let language = sessionStorage.getItem("wmsmlang");
          // if (language == 'zh-TW') {
          //   this.NzMessageService.warning('已終止該合同簽核流程');
          // }
          // if (language == 'zh-CN') {
          //   this.NzMessageService.success('已终止该合同签核流程');
          // }
          // if (language == 'en') {
          //   this.NzMessageService.warning('The contract review process has been terminated');
          // }
          this.GetTable()
        } else {
          this.tanslateService.get('ServerError').subscribe((translatedText: string) => {
            this.NzMessageService.warning(translatedText);
          })
          //this.NzMessageService.warning('内部错误');
        }
      },
      (error) => {
      }
    );
  }


  //重发按钮
  AgainSend() {

    if (this.SelectData == undefined || this.SelectData.length == 0 || this.SelectData == null) {

      return this.tanslateService.get('SelectData').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      // let language = sessionStorage.getItem("wmsmlang");
      // if (language == 'zh-TW') {
      //   return this.NzMessageService.warning('請選擇數據');
      // }
      // if (language == 'zh-CN') {
      //   return this.NzMessageService.warning('请选择数据');
      // }
      // if (language == 'en') {
      //   return this.NzMessageService.warning('Please select data');
      // }
    }
    let shouldExit = false;

    this.SelectData.forEach(data => {
      if (data.schedule === "1") {

        this.tanslateService.get('UploadedContractsCannotResend').subscribe((translatedText: string) => {
          this.NzMessageService.warning(translatedText);
        })
        // let language = sessionStorage.getItem("wmsmlang");
        // if (language == 'zh-TW') {
        //   this.NzMessageService.warning('上傳的合同無法重新發送');
        // }
        // if (language == 'zh-CN') {
        //   this.NzMessageService.warning('已上传合同不可重新发送');
        // }
        // if (language == 'en') {
        //   this.NzMessageService.warning('Uploaded contracts cannot be resend');
        // }
        shouldExit = true; // 设置标志变量为true
      }
      if (shouldExit) {
        return; // 退出循环的执行
      }
    });

    if (shouldExit) {
      return; // 退出外部函数或方法的执行
    }


    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.AgainSendContract.url}`;

    const params = {
      data: {
        scheduleDto: this.SelectData
      }
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {

        if (res.status == 200) {
          this.tanslateService.get('resend').subscribe((translatedText: string) => {
            this.NzMessageService.success(translatedText);
          })
          ///this.NzMessageService.success('已重新发送');
          this.GetTable()
        } else {
          this.NzMessageService.warning(res.msg);
        }
      },
      (error) => {
      }
    );
  }


  //催签按钮
  UrgeContractApproval() {
    if (this.SelectData == undefined || this.SelectData.length == 0 || this.SelectData == null) {

      return this.tanslateService.get('SelectData').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      // let language = sessionStorage.getItem("wmsmlang");
      // if (language == 'zh-TW') {
      //   return this.NzMessageService.warning('請選擇數據');
      // }
      // if (language == 'zh-CN') {
      //   return this.NzMessageService.warning('请选择数据');
      // }
      // if (language == 'en') {
      //   return this.NzMessageService.warning('Please select data');
      // }
    }
    let shouldExit = false;

    this.SelectData.forEach(data => {
      if (data.schedule === "1") {

        this.tanslateService.get('UploadedContractsCannotResend').subscribe((translatedText: string) => {
          this.NzMessageService.warning(translatedText);
        })
        // let language = sessionStorage.getItem("wmsmlang");
        // if (language == 'zh-TW') {
        //   this.NzMessageService.warning('已上傳的合同無法重新發送');
        // }
        // if (language == 'zh-CN') {
        //   this.NzMessageService.warning('已上传合同不可重新发送');
        // }
        // if (language == 'en') {
        //   this.NzMessageService.warning('Uploaded contracts cannot be resend');
        // }
        shouldExit = true; // 设置标志变量为true
      }

      if (shouldExit) {
        return; // 退出循环的执行
      }
    });

    this.SelectData.forEach(data => {
      if (data.schedule === "3") {

        this.tanslateService.get('RejectedContractCannotSign').subscribe((translatedText: string) => {
          this.NzMessageService.warning(translatedText);
        })
        // let language = sessionStorage.getItem("wmsmlang");
        // if (language == 'zh-TW') {
        //   this.NzMessageService.warning('拒簽的合同無法進行催簽');
        // }
        // if (language == 'zh-CN') {
        //   this.NzMessageService.warning('拒签的合同无法进行催签');
        // }
        // if (language == 'en') {
        //   this.NzMessageService.warning('The rejected contract cannot be urged to sign');
        // }
        shouldExit = true; // 设置标志变量为true
      }

      if (shouldExit) {
        return; // 退出循环的执行
      }
    });

    if (shouldExit) {
      return; // 退出外部函数或方法的执行
    }

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UrgeContractApproval.url}`;

    const params = {
      data: {
        scheduleDto: this.SelectData
      }
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.status = 200) {

          this.tanslateService.get('PromptSignatureSuccess').subscribe((translatedText: string) => {
            this.NzMessageService.success(translatedText);
          })
          //   let language = sessionStorage.getItem("wmsmlang");
          // if (language == 'zh-TW') {
          //   this.NzMessageService.success('已催簽');
          // }
          // if (language == 'zh-CN') {
          //   this.NzMessageService.success('已催签');
          // }
          // if (language == 'en') {
          //   this.NzMessageService.success('Have urged for signature');
          // }

          this.GetTable()
        } else {
          this.NzMessageService.warning(res.msg);
        }
      },
      (error) => {
      }
    );
  }


  //采购驳回按钮
  UserReject() {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UserReject.url}`;

    const params = {
      data: {
        scheduleDto: this.SelectData,
        RejectNote: this.validateForm.controls['GroundsRejection'].value,
      }

    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.status = 200) {
          this.tanslateService.get('resend').subscribe((translatedText: string) => {
            this.NzMessageService.success(translatedText);
          })
          // this.NzMessageService.success('已重新发送');
          this.GetTable()
        } else {
          this.tanslateService.get('ServerError').subscribe((translatedText: string) => {
            this.NzMessageService.warning(translatedText);
          })
          // this.NzMessageService.warning('内部错误');
        }
      },
      (error) => {
      }
    );
  }

  //下载合同文件
  GetFile(data) {
    this.webApiService.downloadFileByToken(data.templateFileToken).subscribe(
      (res) => {
        this.downloadFile8(res, data.templateFileName);
        this.tanslateService.get('DownloadSuccessfully').subscribe((translatedText: string) => {
          this.NzMessageService.success(translatedText);
        })
        // let language = sessionStorage.getItem("wmsmlang");
        // if (language == 'zh-TW') {
        //   this.NzMessageService.success('下載成功');
        // }
        // if (language == 'zh-CN') {
        //   this.NzMessageService.success("下载成功");
        // }
        // if (language == 'en') {
        //   this.NzMessageService.success('download successfully');
        // }

      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }


  //厂商拒签
  VendorReject() {

    if (this.SelectData == undefined || this.SelectData.length == 0) {

      return this.tanslateService.get('SelectData').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })

      //   let language = sessionStorage.getItem("wmsmlang");
      //   if (language == 'zh-TW') {
      //  return   this.NzMessageService.warning('請選擇數據');
      //   }
      //   if (language == 'zh-CN') {

      //     return this.NzMessageService.warning('请选择数据');
      //   }
      //   if (language == 'en') {
      //   return  this.NzMessageService.warning('Please select data');
      //   }
    }
    if (this.SelectData.length > 1) {
      return this.tanslateService.get('OnlyOnePieceDataRefused').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      // let language = sessionStorage.getItem("wmsmlang");
      // if (language == 'zh-TW') {
      //   return this.NzMessageService.warning('只能拒簽一條數據');
      // }
      // if (language == 'zh-CN') {
      //   return this.NzMessageService.warning('只能拒签一条数据');
      // }
      // if (language == 'en') {
      //   return this.NzMessageService.warning('Only one piece of data can be sent');
      // }
    }
    if (this.SelectData, length == 1 && this.SelectData[0].schedule == "0") {
      this.IsReject = true
      this.validateForm.controls['VendorRejectText'].setValue(null);
    } else {
      return this.tanslateService.get('CanRefuseVisaAlreadySent').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
      // let language = sessionStorage.getItem("wmsmlang");
      // if (language == 'zh-TW') {
      //   return this.NzMessageService.warning('只能拒簽已發送');
      // }
      // if (language == 'zh-CN') {
      //   return this.NzMessageService.warning('只能拒签已发送');
      // }
      // if (language == 'en') {
      //   return this.NzMessageService.warning('Can only refuse a visa already sent');
      // }
    }


  }

  RejectCancel() {
    this.IsReject = false
  }
  //确定拒签
  RejectOk() {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.VendorReject.url}`;

    const params = {
      data: {
        scheduleDto: this.SelectData,
        RefuseNote: this.validateForm.controls['VendorRejectText'].value,
      }

    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.status = 200) {
          this.tanslateService.get('RejectSuccessfully').subscribe((translatedText: string) => {
            this.NzMessageService.success(translatedText);
          })
          //this.NzMessageService.success('已拒签');
          this.GetTable()
        } else {
          this.tanslateService.get('ServerError').subscribe((translatedText: string) => {
            this.NzMessageService.warning(translatedText);
          })
          //this.NzMessageService.warning('内部错误');
        }
      },
      (error) => {
      }
    );
    this.IsReject = false
  }



  //Vendor上传合同
  beforeUploadVendorFile = (file: NzUploadFile) => {
    this.UploadProofFile = file;
    this.SaveUploadVendorFile(file)
    this.tanslateService.get('UploadSuccess').subscribe((translatedText: string) => {
      this.NzMessageService.success(translatedText);
    })
    // this.NzMessageService.success('Upload Success!');
    this.handleChange
  }

  GetInfo(data, i) {

    this.GuiID = data.id
    this.int = i
    this.database = data;
  }

  SaveUploadVendorFile(file) {


    this.loading = true;
    const formData = new FormData();
    formData.append('Files', file);
    formData.append('VendorContract', 'VendorContract')
    formData.append('TypeCode', this.database.TypeCode.split("/")[0])
    formData.append('Versions', this.database.versions)
    formData.append('VendorCode', this.database.vendorCode)
    formData.append('Status', this.database.status)
    formData.append('Site', this.database.site)
    formData.append('Buyer', this.database.buyer)
    formData.append('ExpirationDate', this.database.expirationDate)
    formData.append('VendorName', this.database.vendorName)
    formData.append('ChContractName', this.database.chContractName)
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UploadVendorContract.url}?id=` + this.GuiID;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http
      .request(req)
      .pipe(filter((e) => e instanceof HttpResponse))
      .subscribe(
        (res) => {
          this.tanslateService.get('UploadSuccess').subscribe((translatedText: string) => {
            this.NzMessageService.success(translatedText);
          })
          // let language = sessionStorage.getItem("wmsmlang");
          // if (language == 'zh-TW') {
          //    this.NzMessageService.success('上傳成功');
          //    this.loading = false;
          // }
          // if (language == 'zh-CN') {
          //    this.NzMessageService.success('上传成功');
          //    this.loading = false;
          // }
          // if (language == 'en') {
          //    this.NzMessageService.success('successfully');
          //    this.loading = false;
          // }
          this.GetTable()
          this.loading = false;


        },
        (error) => {
          this.tanslateService.get('ServerError').subscribe((translatedText: string) => {
            this.NzMessageService.error(translatedText);
          })
          // this.NzMessageService.error('upload failed.');
          this.loading = false;
        }
      );
  }



  //下载供应商上传的合同
  GetVendorFile(data) {
    this.webApiService.downloadFileByToken(data.vendorUptateFileToken).subscribe(
      (res) => {
        this.downloadFile8(res, data.uploadFileName);
        this.tanslateService.get('DownloadSuccessfully').subscribe((translatedText: string) => {
          this.NzMessageService.success(translatedText);
        })
        // this.NzMessageService.success("下载成功");

      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }






  ApproveCancel1() {
    this.isVisible1 = false
  }

  ApproveOk() {
    this.ApproveContract(this.ManagerEmailFile)
    this.isVisible1 = false
  }




  //状态为拒签下的上传主管邮件
  beforeUpload = (file: NzUploadFile) => {
    this.ManagerEmailFile = file;
    if (file.name != null || file.name != undefined) {

      this.ManagerEmailFileName = file.name
    }
    this.tanslateService.get('UploadSuccess').subscribe((translatedText: string) => {
      this.NzMessageService.success(translatedText);
    })
    //this.NzMessageService.success('Upload Success!');
    // this.ApproveContract(file)
  }




  // 核准
  ApproveContract(file) {

    this.loading = true;
    const formData = new FormData();
    formData.append('Files', file);
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.ApproveContract.url}?id=` + this.SelectData[0].id
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http
      .request(req)
      .pipe(filter((e) => e instanceof HttpResponse))
      .subscribe(
        (res) => {
          this.loading = false;
        },
        (error) => {
          this.NzMessageService.error('upload failed.');
          this.loading = false;
        }
      );
  }


  //下载
  download() {
    this.loading = true;
    const startDate = this.formValues.SendDate !== null ? this.getUTC8DateString(this.formValues.SendDate[0]) : '';
    const endDate = this.formValues.SendDate !== null ? this.getUTC8DateString(this.formValues.SendDate[1]) : '';
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownloadQueryExcel.url}?Role=` + this.ConditionRole;
    const params = {
      data: {
        Site: this.formValues.Site,
        ContractName: this.formValues.ContractName,
        Version: this.formValues.Versions,
        Schedule: this.formValues.Schedule,
        VendorCode: this.formValues.Vendor,
        Buyer: this.formValues.Buyer,
        TypeCode: this.formValues.TypeCode,
        SendDateFrom: startDate,
        SendDateTo: endDate,
      }
    };
    this.webApiService.doPost(url, params, true).subscribe((res) => {
      this.tanslateService.get('DownloadSuccessfully').subscribe((translatedText: string) => {
        this.NzMessageService.success(translatedText);
      })
      // this.NzMessageService.success('下载成功');
      this.downloadFile8(res, `Contract_Process_${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
    this.loading = false;
  }




  //多选核准
  ApproveContractOfUpload() {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.ApproveContractOfUpload.url}`;

    const params = {
      data: {
        scheduleDto: this.SelectData,
      }

    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.status = 200) {

          this.tanslateService.get('SuccessfullyApproved').subscribe((translatedText: string) => {
            this.NzMessageService.success(translatedText);
          })
          //   let language = sessionStorage.getItem("wmsmlang");
          // if (language == 'zh-TW') {
          //   this.NzMessageService.success('已成功核准');
          // }
          // if (language == 'zh-CN') {
          //   this.NzMessageService.success('已成功核准');
          // }
          // if (language == 'en') {
          //   this.NzMessageService.warning('Approved successfully');
          // }
          this.GetTable()
        } else {
          this.tanslateService.get('ServerError').subscribe((translatedText: string) => {
            this.NzMessageService.warning(translatedText);
          })
          // this.NzMessageService.warning('内部错误');
        }
      },
      (error) => {
      }
    );
    this.IsReject = false

  }


  public handleChange(info: NzUploadChangeParam): void {
    if (info.file.status === 'done') {
      this.uploadedFileName = info.file.response.name;
    }
  }


  GetmanagerFile(data) {
    this.webApiService.downloadFileByToken(data.managerEmailFileToken).subscribe(
      (res) => {
        this.downloadFile8(res, data.managerEmailFileName);
        this.tanslateService.get('DownloadSuccessfully').subscribe((translatedText: string) => {
          this.NzMessageService.success(translatedText);
        })
        // this.NzMessageService.success("下载成功");

      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }


  onQueryClick() {
    return 'ScheduleManagement';
  }
}


